module.exports = __webpack_public_path__ + "static/img/fristagency-icon1.e591ea2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fristagency-icon1.png
// module id = /VoX
// module chunks = 1